module.exports = __webpack_public_path__ + "static/battery-cea99ae78d3162d6be97ff971935bbcd.svg";